import { FieldValues, Path, useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import { Autocomplete } from 'app/agriculture/forms/components/Autocomplete/Autocomplete';
import { useUsers } from 'app/agriculture/hooks/users/useUsers';

interface UserSelectFieldProps<FormType extends FieldValues> {
    className?: string;
    fieldName: Path<FormType>;
    label: string;
}

export function UserSelectField<FormType extends FieldValues>({
    fieldName,
    className,
    label,
}: UserSelectFieldProps<FormType>) {
    const formController = useFormContext<FormType>();
    const assignedUserIds: number[] = formController.getValues(fieldName);
    const users = useUsers();

    const extraUsers = assignedUserIds
        .filter((userId) => !users.some((user) => user.id === userId))
        .map((userId) => ({ id: userId, name: 'Unknown' }));

    const allUsers = [...users, ...extraUsers];

    return (
        <Autocomplete
            className={classNames(className, 'UserSelectField')}
            fieldName={fieldName}
            options={allUsers}
            noun={label}
            formController={formController}
            rules={{
                validate: {
                    notEmpty: (value) => {
                        if ((value as number[]).length === 0) {
                            return 'Please assign at least one user.';
                        }
                    },
                },
            }}
        />
    );
}
